import styled from "styled-components";
import React from "react";
import Checkbox from "./../../Common/Components/Checkbox";
import { DEFAULT_IMAGE_PLACEHOLDER } from "constants/index";
import { Typography } from "antd";

interface IModalIndivisualItem {
  email: string;
  checked?: boolean;
  onCheckChange?: any;
  color?: string;
  person_name?: string;
  designation?: string;
  imgUrl?: string;
  showCheckbox?: boolean;
}

const { Paragraph } = Typography;

const ModalIndivisualItem: React.FC<IModalIndivisualItem> = (props) => {
  const { email, color, person_name, designation, imgUrl, checked, onCheckChange, showCheckbox } = props;
  return (
    <Wrapper>
      <div className="main">
        {showCheckbox && (
          <div className="checkbox-styles">
            <Checkbox width={"18px"} height={"18px"} checked={checked} onChange={onCheckChange} />
          </div>
        )}
        <span
          className="profile-img-wrapper"
          style={{
            borderColor: color === "" ? "#EFEFEF" : color,
            backgroundColor: color === "" ? "#EFEFEF" : color,
          }}
        >
          <img src={imgUrl || DEFAULT_IMAGE_PLACEHOLDER} className="profile-img" alt="" />
        </span>
        <div className="profile">
          <Paragraph
            className="person-name"
            ellipsis={{
              rows: 1,
              tooltip: person_name?.trim() === "" || person_name === null ? person_name : person_name,
            }}
          >
            {person_name}
          </Paragraph>
          <Paragraph
            className="email"
            ellipsis={{
              rows: 1,
              tooltip: email?.trim() === "" || email === null ? email : email,
            }}
          >
            {email}
          </Paragraph>
          <Paragraph
            className="designation"
            ellipsis={{
              rows: 1,
              tooltip: designation?.trim() === "" || designation === null ? designation : designation,
            }}
          >
            {designation && designation.length > 0 ? designation : ""}
          </Paragraph>
        </div>
      </div>
    </Wrapper>
  );
};

ModalIndivisualItem.defaultProps = {
  showCheckbox: true,
};
export default ModalIndivisualItem;

const Wrapper = styled.div`
  margin-bottom: 8px;
  .main {
    width: 310px;
    height: 48px;
    background: linear-gradient(270.13deg, rgba(255, 255, 255, 0.2) -12.87%, rgba(217, 217, 217, 0) 92.27%);
    display: flex;
    align-items: center;
  }
  .checkbox-styles {
    > div {
      margin-top: 1px;
    }
    margin-left: 8px;
    margin-right: 1px;
    margin-top: 2px;
  }
  .checkbox-styles > div {
    margin-top: 1px;
  }
  .text-area {
    width: calc(100% - 100px);
  }
  .profile {
    margin-left: 8px;
    max-width: 230px;
  }
  .person-name {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 13.1624px;
    line-height: 16px;
    letter-spacing: -0.247912px;
    color: #000000;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 0;
  }
  .email {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 8.77496px;
    line-height: 16px;
    color: #1ec252;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0;
    white-space: nowrap;
  }
  .designation {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 9.87183px;
    line-height: 16px;
    color: #424b50;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0;
    white-space: nowrap;
  }
  .elements-on-right {
    margin-left: auto;
  }
  .person-logo-circle {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), url(people.png);
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    margin-left: 8px;
  }
  .profile-img-wrapper {
    padding: 2px;
    width: 33px;
    height: 33px;
    border-radius: 100%;
    float: left;
    overflow: hidden;
    margin-top: 0px;
    display: flex;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 41px;
      height: 41px;
    }
    .profile-img {
      border-radius: 100%;
      width: 100%;
      height: 100%;
    }
  }
`;
